import get from 'lodash/get';
import { getDeviationType, isLegacyStatus, } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import { useFlag } from '../../../redux/flags/hooks';
export function useDeviationStats(deviation) {
    var isDeviationPostsFlagEnabled = useFlag('deviation_posts');
    var isLegacySimpleType = isLegacyStatus(deviation) ||
        // FEATURE_CLEANUP: deviation_posts Remove the below comparison
        (getDeviationType(deviation) === DeviationTypes.STATUS &&
            !isDeviationPostsFlagEnabled);
    var isSimpleType = [
        DeviationTypes.COMMISSION,
        DeviationTypes.POLL,
    ].includes(getDeviationType(deviation));
    var isComplexType = !isSimpleType && !isLegacySimpleType;
    return {
        faves: get(deviation, 'stats.favourites', 0),
        comments: get(deviation, 'stats.comments', 0),
        views: get(deviation, 'extended.stats.views', 0),
        viewsToday: get(deviation, 'extended.stats.today', 0),
        isCommentable: deviation.isCommentable,
        isFavouritable: isComplexType,
        isViewCountable: isComplexType,
        hasTooltips: isComplexType,
    };
}
//# sourceMappingURL=helpers.js.map